<template>
  <div class="clinicmain">
    <b-container fluid>
      <b-row class="mycontainer-main">
        <!-- <b-col cols="12" md="4" >
                    <div class="row h-100 ml-5 m-borders " >
                        <div class="col-sm-12 align-self-center text-left">
                            <div>
                                <div id="bar" class="bar">
                                </div>
                                <h2 class="fade-in" >{{ $t('clinic-main.jumbo-title') }}</h2>
                                <p class="fade-in" >{{ $t('clinic-main.jumbo-message') }}</p>
                                <b-button squared style="background-color: black;" class="fade-in">{{ $t('common.make-appointment') }} </b-button>                                
                            </div>
                        </div>
                    </div>
                </b-col> -->

        <b-col cols="12" md="4" class="pl-5 leftcontent">
          <h6 class="my-0" style="color: grey">Ville de Quebec</h6>
          <h2>Beauté Intégrale</h2>
          <br />
          <h1 class="pageSubtitle">{{ $t("clinic-main.jumbo-message1") }}</h1>
          <h1 class="pageSubtitle">{{ $t("clinic-main.jumbo-message2") }}</h1>
          <h1 class="pageSubtitle">{{ $t("clinic-main.jumbo-message3") }}</h1>
          <!-- <hr style="width: 70%; margin-left: -10%;"> -->
          <b-button squared variant="outline-dark" class="mt-3 shadow" @click="goBack">
            {{ $t("common.goback") }}</b-button>
          <appt-button v-bind:color="'d'" />
        </b-col>

        <b-col cols="12" md="6" class="align-self-center py-3" id="clinicservices">
          <div class="my-grid">
            <b-card img-top img-src="https://media.beauteintegrale.ca/beaute-integrale-web/images/bi_facial_2024_1.jpg"
              class="shadow">
              <b-card-title style="font-weight: bold">
                {{ $t("clinic-main.aesthetic-services") }}
              </b-card-title>

              <b-button squared style="background-color: black" class="mt-2 shadow" to="/clinic/services">{{
            $t("common.view-services") }}</b-button>
            </b-card>

            <b-card img-top :img-src="getImg('7O9A1099')" class="shadow">
              <b-card-title style="font-weight: bold">{{ $t("clinic-main.online-services") }}
              </b-card-title>

              <b-button squared style="background-color: black" class="mt-2 shadow" to="/onlineconsultation">{{
            $t("common.learn-more") }}</b-button>
            </b-card>
          </div>
          <b-card style="background-color: black" :sub-title="$t('clinic-main.s_consult-title1')" class="shadow mt-3">
            <b-card-title style="font-weight: bold; color: white">{{ $t("clinic-main.s_consult-title") }}
            </b-card-title>
            <b-card-text style="color: white">
              {{ $t("clinic-main.s_consult_desc") }}
            </b-card-text>
            <b-button squared variant="outline-light" class="mt-2" to="/appointment">{{
            $t("common.request-consultation") }}</b-button>
          </b-card>
        </b-col>

        <b-col cols="12" md="2" class="align-self-center">
          <div class="row">
            <b-col cols="12">
              <h3>{{ $t("common.the-team") }}</h3>
            </b-col>
            <b-col cols="6" class="m-borders" style="text-align: center" align-self="center" v-for="(i, index) in staff"
              :key="index">
              <b-img :src="getStaffImg(i.img)" fluid center> </b-img>
            </b-col>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "clinicmain",
  data() {
    return {
      msg: "Welcome to BI",
      staff: [
        { img: "car", name: "Caroline" },
        { img: "Claudia", name: "Claudia" },
        { img: "Emilie", name: "Emily" },
        //   {img: '3', name: "Claudia"},
        { img: "Roxanne", name: "Roxane" },
        { img: "meg2", name: "Meg" },
        { img: "sarah", name: "Sarah" },
        { img: "Alexanne", name: "Alexanne" },
        { img: "Joanie", name: "Joanie" },
        { img: "Laura", name: "Laura" },
        { img: "Brenda", name: "Brenda" },
        // { img: "cyndia", name: "Cydia" },
        { img: "maynika", name: "maynika" },
        { img: "myrianne", name: "myrianne" },
        { img: "nancy", name: "nancy" },
        { img: "eve", name: "eve" },
      ],
    };
  },
  methods: {
    getStaffImg(p) {
      var images = require.context("../assets/images/staff/", false, /\.jpg$/);
      return images("./" + p + ".jpg");
    },
    getImg(p) {
      var images = require.context("../assets/images/", false, /\.jpg$/);
      return images("./" + p + ".jpg");
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mycontainer-main {
  min-height: calc(90vh);
}

/* .mycontainer-main2 {
    min-height: 10vh ;
} */
.m-borders {
  border: 3px solid white;
}

.retail-clinic {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)),
    url("https://media.beauteintegrale.ca/beaute-integrale-web/images/BI_boutique.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: "contain";
}

.retail-clinic h2 {
  color: white;
  font-weight: 400;
}

.main-background {
  background-image: url("../assets/images/waiting_room_front_3.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

h2 {
  font-weight: 400;
}

.brand-bar {
  background-color: lightgray;
}

.bar {
  animation-duration: 3s;
  animation-name: slidein;
  background-color: black;
  height: 25px;
  margin-bottom: 25px;
  margin-left: -25vw;
  margin-right: 25%;
}

.animate-left {
  animation-duration: 3s;
  animation-name: slidein;
}

@keyframes slidein {
  from {
    margin-right: 100%;
  }

  to {
    margin-right: 25%;
  }
}

.search-container button {
  padding: 6px 10px;
  margin-right: 0px;
  background: #ddd;
  font-size: 17px;
  border: none;
  cursor: pointer;
}

.search-container input[type="text"] {
  padding: 6px;
  margin-top: 8px;
  font-size: 17px;
  border: none;
}

.main-button {
  width: 175px;
  text-transform: uppercase;
}

.background-aesthetic {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)),
    url("../assets/images/aesth1.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.background-consultation {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)),
    url("../assets/images/formulary.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

#clinicservices .card-columns {
  column-count: 2;
}



.leftcontent {
  padding-top: 30vh;
  padding-bottom: 10vh;
}

.card-img-top {
  width: 100%;
  height: 20rem;
  object-fit: cover;
}

.my-grid {
  display: grid;
  justify-items: center;
  /* 280px is the minimum a column can get, you might need to adjust it based on your needs. */
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 1.5rem;
}

.my-grid>* {
  width: 100%;
  /* max-width: 28rem; */
}

@media screen and (max-width: 576px) {
  #clinicservices .card-columns {
    column-count: 1;
  }

  .leftcontent {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/ClinicMain.vue